import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';

export const SegmentEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm();

  return (
    <Edit saveButtonProps={{ ...saveButtonProps }}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name={['name']}
          rules={[
            {
              required: true,
              message: 'Please enter a valid product segment name',
            },

            {
              min: 3,
              message: 'The segment name must be at least 3 characters long.',
            },
            {
              max: 30,
              message:
                'The segment name cannot be more than 30 characters long.',
            },
            {
              type: 'string',
              whitespace: true,
            },
            {
              pattern: /^[a-zA-Z]+$/,
              message: 'Please enter a valid product segment name.',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
